module.exports = __webpack_public_path__ + "img/f4.6f20d305.png";